module.exports = __webpack_public_path__ + "assets/419d475359b0d322b6e092c2cd184fbf.png";